document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-info').forEach((productInfo) => {
    const sectionId = productInfo.dataset.section;
    const config = window.variantGalleryRules?.[sectionId];

    if (!config) return;

    const productSection = productInfo.closest('.shopify-section') || document;
    
    const mediaItems = productSection.querySelectorAll(
      '.product__media-item, .thumbnail-list__item'
    );
    
    function normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function getSelectedOptions() {
      const options = [];

      productInfo
        .querySelectorAll('variant-selects select, variant-radios input[type="radio"]:checked')
        .forEach((input) => {
          options.push(input.value);
        });

      return options;
    }

    function getKeyword(options) {
      if (!options.length) return '';

      const optionA = normalize(options[config.optionA]);

      if (!optionA) return '';

      const optionB = normalize(
        config.optionB !== undefined ? options[config.optionB] : ''
      );

      const match = config.rules.find((rule) => {
        const ruleA = normalize(rule.a);
        const ruleB = normalize(rule.b);

        const optionAMatches = !ruleA || optionA.includes(ruleA);
        const optionBMatches = !ruleB || optionB.includes(ruleB);

        return optionAMatches && optionBMatches;
      });

      return match ? match.keyword : '';
    }

    function updateGallery() {
      const selectedOptions = getSelectedOptions();
      const keyword = normalize(getKeyword(selectedOptions));

      if (!keyword) return;

      mediaItems.forEach((item) => {
        const img = item.querySelector('img');

        const searchableText = normalize(
          `${img?.alt || ''} ${img?.currentSrc || img?.src || ''}`
        );

        const shouldShow = searchableText.includes(keyword);

        item.hidden = !shouldShow;
        item.style.display = shouldShow ? '' : 'none';
      });
    }

    updateGallery();

    productInfo.addEventListener('change', () => {
      setTimeout(updateGallery, 50);
    });
  });
});